// https://github.com/chakra-ui/chakra-ui/blob/master/packages/theme/src/components/alert.ts

import { mode } from "@chakra-ui/theme-tools"

const Alert = {
  parts: ["description", "icon"],
  baseStyle: {
    container: {
      rounded: "sm",
      shadow: "sm",
      borderWidth: "1px",
      borderColor: "border"
    },
    description: {
      fontSize: "sm",
      text: "red.400",
      width: "100%"
    },
  },
  variants: {
    solid: (props) => ({
      container: {
        bg: "bg.high",
        // close icon and description color
        color: "text.soft"
      },
      title: {
        color: "text"
      },
      icon: {
        color: mode(`${props.colorScheme}.800`, `${props.colorScheme}.300`)(props),
      },
    })
  },
}

export default Alert
